import { type ValidationError } from '@adv-frontend/form-kit';

export const MAX_VALUE_ERROR_CODE = 'MAX_VALUE_ERROR';

type MaxValueErrorParams = {
    maxValue: number;
};

export type MaxValueValidationError = ValidationError<typeof MAX_VALUE_ERROR_CODE, MaxValueErrorParams>;

export const MAX_VALUE_ERROR_MESSAGE = ({ maxValue }: MaxValueErrorParams) =>
    `Превышение максимального значения ${maxValue}`;
